// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Counter-base___apo8{display:inline-flex;align-items:center;justify-content:center;min-width:var(--size-5);height:var(--size-5);padding:0 var(--size-1);color:var(--gray-12);background:var(--gray-a2);border:var(--size-0_25) solid var(--gray-a4);border-radius:var(--border-radius-1);font:var(--font-caption-small-500);font-feature-settings:var(--feature-settings-caption-small-500);letter-spacing:var(--letter-spacing-caption-small-500)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Counter-base___apo8"
};
export default ___CSS_LOADER_EXPORT___;
